import { styled } from '@mui/material/styles'

const buttonStyle = {
  fontFamily: 'Arial',
  display: 'flex',
  alignItems: 'center',
  position: 'absolute',
  zIndex: 2,
  bottom: '5vh',
  color: '#fff',
  border: 0,
  fontWeight: 500,
  fontSize: '0.875rem',
  lineHeight: 1.75,
  letterSpacing: '0.02857em,',
  textTransform: 'uppercase',
  minWidth: 100,
  padding: '6px 16px',
  borderRadius: 4,
  boxShadow: '0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)'
}
const getStyles = (theme) => (
  {
    root: {
      position: 'fixed',
      height: '100vh',
      width: '100%',
      top: 0,
      left: 0
    },
    btnDown: {
      backgroundColor: theme.palette?.primary.main,
      right: '5vh',
      ...buttonStyle
    },
    btnLeft: {
      backgroundColor: 'gray',
      left: '5vh',
      ...buttonStyle
    },
    activeIcon: {
      color: `${theme.palette?.primary.main} !important`
    },
    screen: {
      position: 'relative'
    },
    fullScreen: {
      width: '100%'
    },
    middleScreen: {
      width: '50%'
    },
    hiddenScreen: {
      width: 0
    }
  }
)
const PREFIX = 'ViewerUnitStyle'
const classes = {}
const classNames = Object.keys(getStyles({}))

classNames.forEach(key => {
  classes[key] = `${PREFIX}-${key}`
})

const ViewerUnitStyle = styled('div')(({ theme }) => {
  const styles = getStyles(theme)
  const myClass = {}
  classNames.forEach(key => {
    const className = key === 'root' ? `&.${classes.root}` : `& .${classes[key]}`
    myClass[className] = {
      ...styles[key]
    }
  })
  return (myClass)
})

export {
  classes,
  ViewerUnitStyle
}
